import { render, staticRenderFns } from "./LeadGenerationPage.vue?vue&type=template&id=463c63ec&scoped=true"
import script from "./LeadGenerationPage.vue?vue&type=script&lang=js"
export * from "./LeadGenerationPage.vue?vue&type=script&lang=js"
import style0 from "./LeadGenerationPage.vue?vue&type=style&index=0&id=463c63ec&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "463c63ec",
  null
  
)

export default component.exports